<template>
    <div class="linkedin-contact-list-switcher">
        <LinkedinContactList
            :channelId="selectedChannelId"
            :channel="getSelectedChannel()"
            :show-title="false"
            allow-import
            :forbidden="isForbidden(getSelectedChannel())"
            :allChannelMode="allChannel"
        >
            <template v-slot:left-actions>
                <div class="channel-switcher">
                    <div class="d-flex gap-5">
                        <a-switch v-model="allChannel" />
                        <span>{{ $t("instagram.showAllLinkedinChannels") }}</span>
                    </div>

                    <ChannelPicker
                        auto-select-first
                        include-deleted
                        v-model="selectedChannelId"
                        :allowed-types="['linkedin-unipile']"
                        :disabled="allChannel"
                        v-if="!allChannel"
                    />
                </div>
            </template>
        </LinkedinContactList>
    </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import { CHANNEL_API } from "../../../../api/channel";
import _ from "lodash";
import ChannelPicker from "../../../../components/pickers/ChannelPicker.vue";
import LinkedinContactList from "./LinkedinContactList.vue";

export default Vue.extend({
    name: "LinkedinContactListSwitcher",
    components: { LinkedinContactList, ChannelPicker },
    data() {
        return {
            channels: [],
            selectedChannelId: null,
            allChannel: false,
        };
    },
    computed: {
        ...mapState({
            activeChannels: (state) =>
                state.channel.channels.filter((channel) => ["linkedin-unipile"].includes(channel.type)),
        }),
        ...mapGetters({
            isChannelVisibleForMe: "channel/isChannelVisibleForMe",
        }),
    },
    created() {
        this.channels = this.activeChannels;
        this.selectedChannelId = this.activeChannels[0]?._id;
    },
    methods: {
        isForbidden(channel) {
            console.log("isForbidden", { channel, visibleToMe: this.isChannelVisibleForMe(channel) });
            return !this.isChannelVisibleForMe(channel);
        },
        fetchChannels() {
            CHANNEL_API.listChannels(true).then((response) => {
                this.channels = response.data.filter((channel) => ["linkedin-unipile"].includes(channel.type));
                this.channels = _.orderBy(this.channels, ["isDeleted", "name"], ["asc", "asc"]);
                this.selectedChannelId = this.channels[0]?._id;
            });
        },
        onChangeChannel(channelId) {
            this.selectedChannelId = channelId;
        },
        getSelectedChannel() {
            return this.channels.find((channel) => channel._id === this.selectedChannelId);
        },
    },
    mounted() {
        this.fetchChannels();
    },
});
</script>

<style lang="scss">
.linkedin-contact-list-switcher {
    display: flex;
    flex-direction: column;

    .channel-switcher {
        width: 100%;
        min-width: 200px;
        display: flex;
        gap: 10px;
        align-items: center;
    }
}
</style>
